import * as React from "react";

import { Viewport, ViewSmall, ViewLarge } from "bernie-view";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";
import { TripAttachQualificationViewProps, viewportConfigs, ViewportSizes } from "./typings";
import { TripCard } from "./components/TripCard";
import { AttachSavingsCard } from "./components/AttachSavingsCard";
import { locKeys } from "./l10n";
import {
  PageBackgroundContext,
  BackgroundColorTokens,
} from "src/components/flexComponents/PageLevelProviders/PageBackgroundColor/PageBackgroundContext.tsx";

export const TripAttachQualificationView = (props: TripAttachQualificationViewProps) => {
  const { formatText } = useLocalization();
  const headingConfig: UitkHeadingProps = { tag: "h2", size: 3 };
  const backgroundColor = React.useContext(PageBackgroundContext);
  const withBorder = backgroundColor === BackgroundColorTokens.BACKGROUND_WHITE;
  const padded = true;

  const renderCards = ({ viewport = ViewportSizes.SMALL }: { viewport?: ViewportSizes }) => {
    const { wrap, minWidth } = viewportConfigs[viewport];

    return (
      <UitkLayoutFlex className="TripAttachQualification all-t-padding-four all-b-padding-six" space="two" wrap={wrap}>
        <UitkLayoutFlexItem minWidth={minWidth} grow={1}>
          <div>
            <TripCard
              destinationName={props.destinationName}
              imageData={props.imageData}
              moduleName={props.moduleName}
              tripEndDate={props.tripEndDate}
              tripStartDate={props.tripStartDate}
              withBorder={withBorder}
            />
          </div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem minWidth={minWidth} grow={1}>
          <div>
            <AttachSavingsCard
              deepLink={props.deepLink}
              deepLinkMipType={props.deepLinkMipType}
              moduleName={props.moduleName}
              percentageOff={props.percentageOff}
              withBorder={withBorder}
              padded={padded}
            />
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    );
  };

  return (
    <div className="TripAttachQualification all-b-margin-six">
      <div className="all-t-margin-three">
        <UitkHeading {...headingConfig}>{formatText(locKeys.moduleTitle)}</UitkHeading>
      </div>

      <Viewport>
        <ViewSmall>{renderCards({})}</ViewSmall>
        <ViewLarge>{renderCards({ viewport: ViewportSizes.LARGE })}</ViewLarge>
      </Viewport>
    </div>
  );
};

export default TripAttachQualificationView;
